module.exports = __webpack_public_path__ + "static/media/home.made.lovely-IG-5.7588ad05.PNG";